import { API, unwrapData } from '../axios-instance'
import { CreateRefinementParams, Refinement } from './types'

export const createRefinement = async (params: CreateRefinementParams) => {
  return await API.post<Refinement>('/refinement/refinements', params).then(unwrapData)
}

export const deleteRefinement = async (refinementId: string) => {
  return await API.delete<boolean>(`/refinement/refinements/${refinementId}`)
}
